import { cn } from "@/lib/utils";

interface CardProps {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  onClick?: () => void;
}

export function Card({ className, style, children, onClick }: CardProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        "rounded-2xl border p-5",
        onClick && "cursor-pointer hover:border-orange-500/30 transition-colors",
        className,
      )}
      style={{
        backgroundColor: "#1F2933",
        borderColor: "rgba(229,231,235,0.08)",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

interface CardStatProps {
  label: string;
  value: string | number;
  sub?: string;
  accent?: boolean;
}

export function CardStat({ label, value, sub, accent }: CardStatProps) {
  return (
    <Card>
      <div className="text-xs font-medium mb-1" style={{ color: "#6B7280" }}>
        {label}
      </div>
      <div className="text-2xl font-bold" style={{ color: accent ? "#F97316" : "#FFFFFF" }}>
        {value}
      </div>
      {sub && (
        <div className="mt-1 text-xs" style={{ color: "#6B7280" }}>
          {sub}
        </div>
      )}
    </Card>
  );
}
